import { render } from "./CertificateCreate.vue?vue&type=template&id=0b4b9c08"
import script from "./CertificateCreate.vue?vue&type=script&lang=js"
export * from "./CertificateCreate.vue?vue&type=script&lang=js"

import "./CertificateCreate.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script